import React from "react";
import PropertyCalendar from '../PropertyCalendar/PropertyCalendar';
import DashboardActions from './actions/DashboardActions';
import { addDays } from 'date-fns';

class WeeklyDashboard extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var startOfWeek = new Date(this.props.currentDate);
    var endOfWeek = addDays(startOfWeek, 6);
    
		return (
			<PropertyCalendar 
				date_format={this.props.dateFormat} 
				time_format={this.props.timeFormat} 
				date_data={this.props.dateData}
				start_date={startOfWeek} 
				end_date={endOfWeek} 
				reservation_segments={this.props.reservationSegments}
				onExpandCollapseRoomType={this.props.isHousekeeping ? this.props.onExpandCollapseRoomType : DashboardActions.onExpandCollapseRoomType}
				room_types={this.props.roomTypes}
				view_mode="weekly"
				show_housekeeping={this.props.isHousekeeping ? this.props.showHousekeeping : false}
				isHousekeeping={this.props.isHousekeeping ? this.props.isHousekeeping : false}
			/>
		);
	}

}

export default WeeklyDashboard